export default __webpack_public_path__ + "static/media/coin.98b302d8.png";